(() => {
  const form = document.querySelector('[data-product-form]');
  if (!form) return;
  const dataEl = document.querySelector('[data-variant-json]');
  if (!dataEl) return;
  const variants = JSON.parse(dataEl.textContent);
  const idInput = form.querySelector('input[name="id"]');
  const priceEls = document.querySelectorAll('[data-price]');
  const compareEl = document.querySelector('[data-compare-price]');
  const saveEl = document.querySelector('[data-save]');
  const buyBtn = form.querySelector('[data-add-button]');
  const money = (cents) => {
    const format = dataEl.dataset.moneyFormat || '₹{{amount}}';
    const amount = (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    return format.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
  };

  form.addEventListener('change', (e) => {
    if (!e.target.matches('[data-option-input]')) return;
    const selected = [...form.querySelectorAll('[data-option-input]:checked, select[data-option-input]')].map((el) => el.value);
    const match = variants.find((v) => v.options.every((opt, i) => opt === selected[i]));
    if (!match) return;
    idInput.value = match.id;
    if (match.featured_media && window.activateProductMedia) window.activateProductMedia(match.featured_media.id);
    priceEls.forEach((el) => { el.textContent = money(match.price); });
    if (compareEl) {
      compareEl.hidden = !(match.compare_at_price > match.price);
      if (!compareEl.hidden) compareEl.textContent = money(match.compare_at_price);
    }
    if (saveEl) {
      const save = match.compare_at_price > match.price ? Math.round((1 - match.price / match.compare_at_price) * 100) : 0;
      saveEl.hidden = save === 0;
      if (save) saveEl.textContent = saveEl.dataset.saveTemplate.replace('[percent]', save + '%');
    }
    if (buyBtn) {
      buyBtn.disabled = !match.available;
      if (match.available) {
        const price = Object.assign(document.createElement('span'), { className: 'product__add-price', textContent: ` — ${money(match.price)}` });
        buyBtn.replaceChildren(buyBtn.dataset.textAdd, price);
      } else {
        buyBtn.textContent = buyBtn.dataset.textSoldOut;
      }
      const stickyBtn = document.querySelector('[data-sticky-add]');
      if (stickyBtn) { stickyBtn.disabled = !match.available; stickyBtn.textContent = match.available ? buyBtn.dataset.textAdd : buyBtn.dataset.textSoldOut; }
    }
    const url = new URL(window.location.href);
    url.searchParams.set('variant', match.id);
    window.history.replaceState({}, '', url.toString());
  });
})();
